import { apiRequest } from './client';
import type { StoredUser } from '../auth/tokenStorage';

export interface PairInitResponse {
  pair_code: string;
  pairing_id: string;
  expires_in: number;
}

export type PairPollResponse =
  | { status: 'pending' }
  | { status: 'expired' }
  | {
      status: 'approved';
      access_token: string;
      refresh_token: string;
      user: StoredUser;
    };

export function pairInit(): Promise<PairInitResponse> {
  return apiRequest<PairInitResponse>('/cabin/pair-init', {
    method: 'POST',
    body: {},
    auth: false,
  });
}

export function pairPoll(pairingId: string, signal?: AbortSignal): Promise<PairPollResponse> {
  const opts: { auth: false; signal?: AbortSignal } = { auth: false };
  if (signal) opts.signal = signal;
  return apiRequest<PairPollResponse>(
    `/cabin/pair-poll?pairing_id=${encodeURIComponent(pairingId)}`,
    opts,
  );
}
